import Loading from '@fuse/components/FuseLoadable/Loading';
import { Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import withReducer from 'app/store/withReducer';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/ChaveActions';
import reducer from './Store/Reducers/ChaveReducer';

const filterApp = [
    { "label": "Descrição", "value": "chave.descricao", "tipo": "string" },
    { "label": "Código", "value": "chave.codigo", "tipo": "string" }
]

const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

class VincularChaveApp extends XAPPComponent {

    state = {
        status: 0
    };

    componentDidMount() {
        const xappRouteParams = this.props.match.params;
        this.props.save({ tipo: this.props.tipo, status: 1, codigo: xappRouteParams.codigo }, xappRouteParams, "ALTERARSTATUSCHAVE");
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.Chave.error) {
            this.setState({ status: -1 });
            this.props.Chave.error = null;
        }
        if (this.props.Chave.info) {
            this.setState({ status: 1 });
            this.props.Chave.info = null;
        }
    }

    render() {
        const xappRouteParams = this.props.match.params;

        return (
            <React.Fragment>
                <div className="h-full items-center">
                    {this.state.status === 0 ?
                        <div className="flex flex-col items-center justify-center h-full">
                            <Loading pastDelay={true} />
                        </div>
                        :
                        <div className="flex flex-col items-center justify-center h-full">
                            {this.state.status === 1 ?
                                <React.Fragment>
                                    <Typography color="textSecondary" variant="h6">
                                        Vinculo criado com sucesso!
                                    </Typography>
                                    <Typography color="textSecondary" variant="h6">
                                        Atualize para acessar
                                    </Typography>
                                    <div className="flex flex-col mt-12">
                                        <XAPPButton
                                            type="Button"
                                            className=""
                                            variant="contained"
                                            iconProps={"mr-8"}
                                            color="secondary"
                                            onClick={() => document.location.href = ("/" + xappRouteParams.organizacao + "/" + xappRouteParams.empresa + "/pub-logout")}
                                            label="Acessar"
                                            icon="login"
                                        />
                                    </div>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <Typography color="textSecondary" variant="h6">
                                        Não foi possível vincular a essa empresa!
                                    </Typography>
                                    <Typography color="textSecondary" variant="h6">
                                        Tente novamente mais tarde ou entre em contato com o adminstrador do sistema.
                                    </Typography>
                                    <div className="flex flex-col mt-12">
                                        <XAPPButton
                                            type="Button"
                                            className=""
                                            variant="contained"
                                            iconProps={"mr-8"}
                                            color="secondary"
                                            onClick={() => document.location.reload(true)}
                                            label="Tentar novamente"
                                            icon="refresh"
                                        />
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    }
                </div>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
    }, dispatch);
}

function mapStateToProps({ Chave }) {
    return {
        Chave: Chave,
    }
}

export default withReducer('Chave', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(VincularChaveApp))));
